export default __webpack_public_path__ + "static/media/Untitled_Artwork.b4eb6503.png";